export enum SizeOption {
  EXTRA_SMALL = "XS",
  SMALL = "S",
  MEDIUM = "M",
  LARGE = "L",
  EXTRA_LARGE = "XL",
  FREE_SIZE = "Free Size",
}
